import { BadgesTypes } from './prop_types';

const Badges = ({ badges }) => (
  <div className="card-badge__badges">
    {badges.map((badge) => (
      <div
        className="rounded-pill px-3 mt-2 py-1"
        key={badge.id}
        style={{
          backgroundColor: badge.badgeColour,
          color: badge.badgeTextColour,
        }}
      >
        <i className={`${badge.badgeIcon} me-1`} />
        {badge.title}
      </div>
    ))}
  </div>
);

export { Badges };

Badges.propTypes = BadgesTypes;
